module.exports = __webpack_public_path__ + "static/media/chalkboard.ae5cb170.svg";